import { generateId } from '@freelancer/datastore/testing/helpers';
import type {
  SupportBanner,
  SupportViewDetails,
} from './support-view-details.model';

export interface GenerateSupportViewDetailsOptions {
  readonly id?: number;
  readonly activeBanner?: SupportBanner;
  readonly hasTicketHistory?: boolean;
  readonly ticketHistoryUrl?: string;
  readonly isSupportChannelEnabled?: boolean;
}

export function generateSupportViewDetailsObject({
  id = 0,
  activeBanner,
  hasTicketHistory = false,
  ticketHistoryUrl = '',
  isSupportChannelEnabled = true,
}: GenerateSupportViewDetailsOptions = {}): SupportViewDetails {
  return {
    id,
    activeBanner,
    hasTicketHistory,
    ticketHistoryUrl,
    isSupportChannelEnabled,
  };
}

// Mixins

export function withSupportBanner({
  title = 'Support Banner Title',
  description = 'Support Banner Description',
}): Pick<GenerateSupportViewDetailsOptions, 'activeBanner'> {
  return {
    activeBanner: {
      id: generateId(),
      subject: title,
      message: description,
    },
  };
}
